module.exports = __webpack_public_path__ + "static/media/lucina-icon.c7a054ab.png";